import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    Box,
    Card,
    CardContent,
    Grid,
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import TransferForm from './TransferForm';
import { Edit, AddCircle, Refresh, CloudDownloadRounded, EditRounded, DeleteRounded } from '@mui/icons-material';
import { InputSelectMulti, InputSelectNative } from '../../common/Form';
import { MONTHS } from '../../../utils/generalFuncs';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
import BankSingle from '../Banks/BankSingle';
// import TransferDetails from './TransferDetails';

class TransfersList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        openForm: false,
        openDetails: false,
        openBank: false,
        selected: {},
        selectedBank: {},
        searchPayMode: "",
        searchMonth: "",
        searchYear: "",
        searchBankS: {value: "", label: ""},
        searchBankD: {value: "", label: ""},

    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    componentDidMount = () => {
        if(isEmpty(this.props.TRANSFERS)){
            this.props.fetchTransfers()
        }   
        if(isEmpty(this.props.BANKS)){
            this.props.fetchBanks()
        }   
        if(isEmpty(this.props.POSTS)){
            this.props.fetchPosts()
        }   
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
            page: 0,
        })
    
    }
    handleSelect = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
                page: 0,
            })
        } else {
            this.setState({
                searchEmployee: {label: "", value: ""},
                page: 0,
            })

        }
    }
    filterList = () => {
        const { searchBankS, searchBankD, searchYear, searchMonth, searchPayMode} = this.state;
        const { TRANSFERS } = this.props
        
        let filteredList = Object.values(TRANSFERS)
        if( !isEmpty(searchPayMode)) {
            filteredList = filteredList.filter( item => item.transfer_payment_mode === searchPayMode)
        }
         
        if( !isEmpty(searchBankS.value)) {
            filteredList = filteredList.filter( item => item.transfer_bank_src === searchBankS.value)
        }
        if( Array.isArray(searchBankS) && !isEmpty(searchBankS) ) {
            let itemList = searchBankS.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.transfer_bank_src))
        }
        if( !isEmpty(searchBankD.value)) {
            filteredList = filteredList.filter( item => item.transfer_bank_dest === searchBankD.value)
        }
        if( Array.isArray(searchBankD) && !isEmpty(searchBankD) ) {
            let itemList = searchBankD.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.transfer_bank_dest))
        }
        
        if( !isEmpty(searchMonth.value) ) {
            filteredList = filteredList.filter( item => new Date(item.transfer_date).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
            let itemList = searchMonth.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.transfer_date).getMonth()))
        } 

        if( searchYear ) {
            filteredList = filteredList.filter( item => new Date(item.transfer_date).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.transfer_date).getFullYear()))
        } 

        return filteredList
    }
    displayList = () => {
        const { TRANSFERS, POSTS, BANKS } = this.props;
        let tab = []
        let rows = 0

        if (!isEmpty(TRANSFERS) && !isEmpty(POSTS) && !isEmpty(BANKS) ){
            let filteredList = this.filterList()
            rows = size(filteredList)
            console.log({filteredList});
            tab.push( this.getTransferList(filteredList))
        }
        return [tab, rows]
    }
    getTransferList = (list) => {
        const { BANKS } = this.props
        const { rowsPerPage, page } = this.state;

            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                return (
                    <TableRow hover key={item.post_id} className="clickable"
                        // onClick={() => this.setState({ openDetails: true, selected: item })}    
                        title="Voir le Détail"
                    >
                        <TableCell>{new Date(item.transfer_date).toLocaleDateString('fr-FR')}</TableCell>
                        <TableCell>{item.transfer_desc}</TableCell>
                        <TableCell
                            onClick={() => this.setState({openBank: true, selectedBank: (item.transfer_bank_src && BANKS[item.transfer_bank_src]) }) }
                            className="a-like"
                        >
                            {item.transfer_bank_src && BANKS[item.transfer_bank_src].bank_name}
                        </TableCell>
                        <TableCell
                            onClick={() => this.setState({openBank: true, selectedBank: (item.transfer_bank_dest && BANKS[item.transfer_bank_dest]) }) }
                            className="a-like"
                        >
                            {item.transfer_bank_dest && BANKS[item.transfer_bank_dest].bank_name}
                        </TableCell>
                        <TableCell><Currency value={item.transfer_amount} /></TableCell>
                        <TableCell>{item.transfer_payment_mode}</TableCell>
                        <TableCell onClick={ () => this.setState({openUpdate: true, selected: item}) }>
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <EditRounded />
                            </IconButton> 
                        </TableCell>      
                        <TableCell onClick={ () => this.setState({openDelete: true, selected: item}) }>
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <DeleteRounded />
                            </IconButton> 
                        </TableCell>      
                    </TableRow>
                )
            })
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openUpdate: false,
            openDelete: false,
            openBank: false,
            openForm: false,
            selected: {},
            selectedBank: {},
        });
    };    
    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteTransfer(selected)
        if(this.props.STATE.transfers.error){
            this.props.notif("error", this.props.STATE.transfers.error)
        } else {
            this.props.notif("success", "Paiement supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
    render() {
        const { TRANSFERS, BANKS } = this.props;
        const { rowsPerPage, page, openForm, openDetails, selected, openDelete, openUpdate, openBank, selectedBank } = this.state;
        let YEARS = []
        for (let year = 2019; year <= new Date().getFullYear(); year++) {
            YEARS.push(year)
        }
        console.log('==== STATE TRANSFER LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let list = this.displayList()
        return (
            <div>
                {openForm &&
                    <TransferForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {/* {openDetails && !isEmpty(selected) && 
                    <TransferDetails open={openDetails} handleClose={this.handleClose} {...this.props} transfer={selected} />
                } */}
                {openUpdate && !isEmpty(selected) &&
                    <TransferForm 
                        update 
                        transfer={selected} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }

                {openBank && !isEmpty(selectedBank) &&
                    <BankSingle 
                        bank={selectedBank} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        budget_year={this.state.searchYear}
                    />
                }
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"le Transfert"}
                        close={this.handleClose}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.transfers.fetching}
                    >
                        Paiement du {new Date(selected.transfer_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.transfer_amount} />
                    </DeleteDialog>
                }
                
                <Typography variant="h6" id="tableTitle">
                    Liste des Transferts
                </Typography>

                <Box style={{textAlign: "right"}}>
                    <Button variant="contained" color="secondary" 
                        onClick={() => this.setState({ openForm: true })} 
                        title="Nouveau Transfert"
                    >
                        <AddCircle />
                        Créer
                    </Button>
                    {/* {this.props.isSuper &&
                        <IconButton color="primary" onClick={this.props.recalcTransfers}>
                            <Refresh />
                        </IconButton>
                    } */}
                    <IconButton
                        color="primary"
                        onClick={() => this.props.openFormDownload("/extract/transfers")}
                        title="Télécharger"
                        disabled={this.props.downloading}
                        size="large">
                        <CloudDownloadRounded />
                    </IconButton>
                </Box>
                <Card>
                <CardContent>
                    <Grid container>
                        <Grid item xs={6}>
                            <InputSelectMulti
                                label="Mois"
                                name="searchMonth"
                                onChange={(option) => this.handleSelect(option, "searchMonth")}
                                value={this.state.searchMonth}
                                id="searchMonth"
                                options={MONTHS.map( (month, index) => ({
                                    label: month,
                                    value: index,
                                    disabled: Array.isArray(this.state.searchMonth) && !!this.state.searchMonth.find(element => element.value === index)
                                    
                                })) }
                                isMulti
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputSelectNative
                                label="Année"
                                name="searchYear"
                                onChange={this.handleChange}
                                value={this.state.searchYear}
                                labelWidth={70} 
                                id="searchYear"
                                options={YEARS.map( year => (
                                    <option value={year} key={year}>
                                        {year}
                                    </option>
                                )) }
                            />
                        </Grid>
                        
                        {!isEmpty(BANKS) && 
                            <Grid item xs={6}>
                                <InputSelectMulti
                                    label="Banque Source"
                                    options={Object.values(BANKS).map( item => ({
                                        label: `${item.bank_name}`,
                                        value: item.bank_id,
                                        disabled: (
                                            Array.isArray(this.state.searchBankD) && !!this.state.searchBankD.find(element => element.value === item.bank_id) ||
                                            Array.isArray(this.state.searchBankS) && !!this.state.searchBankS.find(element => element.value === item.bank_id)
                                        )
                                    }))}
                                    value={this.state.searchBankS}
                                    onChange={(option) => this.handleSelect(option, "searchBankS")}
                                    isMulti
                                />
                            </Grid>
                        }
                        {!isEmpty(BANKS) && 
                            <Grid item xs={6}>
                                <InputSelectMulti
                                    label="Banque Destinataire"
                                    options={Object.values(BANKS).map( item => ({
                                        label: `${item.bank_name}`,
                                        value: item.bank_id,
                                        disabled: (
                                            Array.isArray(this.state.searchBankD) && !!this.state.searchBankD.find(element => element.value === item.bank_id) ||
                                            Array.isArray(this.state.searchBankS) && !!this.state.searchBankS.find(element => element.value === item.bank_id)
                                        )
                                        
                                    }))}
                                    value={this.state.searchBankD}
                                    onChange={(option) => this.handleSelect(option, "searchBankD")}
                                    isMulti
                                />
                            </Grid>
                        }

                        <Grid item xs={12} sm={6} >
                            <InputSelectNative
                                label="Mode de Paiement"
                                name="searchPayMode"
                                onChange={this.handleChange}
                                value={this.state.searchPayMode}
                                labelWidth={150} 
                                options={[
                                    <option value="ESPECES">ESPECES</option>,
                                    <option value="CHEQUE">CHEQUE</option>,
                                    <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                    <option value="VIREMENT">VIREMENT</option>,
                                    <option value="GAB">GAB</option>,
                                    <option value="MOBILE MONEY">MOBILE MONEY</option>,
                                    <option value="COLLAB">COLLAB</option>,
                                ]}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                </Card>
                
                {!isEmpty(TRANSFERS) && 
                    <div className="table-responsive">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Créé le</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Banque Source</TableCell>
                                    <TableCell>Banque Destinataire</TableCell>
                                    <TableCell>Montant</TableCell>
                                    <TableCell>Mode</TableCell>
                                    <TableCell>Modifier</TableCell>
                                <TableCell>Supprimer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list[0]}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[20, 30]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={9}
                                        count={list[1]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table> 
                    </div>
                }
            </div>
        );
    }
}

export default TransfersList;